import React, { useState, useEffect } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";

import Utils from "../../configs/Utils";
import Enums from "../../configs/Enums";

const INITIAL_FORM_DATA = {
  sku: "",
  productName: "",
  imageUrl: "",
};

const ProductForm = ({ workspaceId, setPopupShow, refreshList, selectedProduct }) => {
  const [formData, setFormData] = useState(INITIAL_FORM_DATA);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (selectedProduct) {
      setFormData({
        sku: selectedProduct.sku || "",
        productName: selectedProduct.productName || "",
        imageUrl: selectedProduct.imageUrl || "",
      });
      return;
    }
    setFormData(INITIAL_FORM_DATA);
  }, [selectedProduct]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const payload = { ...formData, workspace: workspaceId };

      if (selectedProduct) {
        const res = await Utils._apiRequest({
          path: `${Enums.endpoints.supplierStock.PRODUCTS}/${selectedProduct._id}`,
          type: "PUT",
          payload,
        });
        if (res.errors) throw new Error(res.errors);
        toast.success("Cập nhật sản phẩm thành công");
      } else {
        const res = await Utils._apiRequest({
          path: Enums.endpoints.supplierStock.PRODUCTS,
          type: "POST",
          payload,
        });
        if (res.errors) throw new Error(res.errors);
        toast.success("Tạo sản phẩm thành công");
      }

      refreshList();
      setPopupShow(false);
    } catch (error) {
      toast.error(error.message || "Lỗi khi lưu sản phẩm");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit} className="supplier-stock-form">
      <section className="supplier-stock-form__intro">
        <span className="supplier-stock-form__eyebrow">
          {selectedProduct ? "Chỉnh sửa sản phẩm" : "Tạo sản phẩm mới"}
        </span>
        <h3>{selectedProduct ? "Cập nhật thông tin sản phẩm" : "Thêm sản phẩm mới"}</h3>
        <p>Nhập thông tin sản phẩm: SKU, tên, và hình ảnh.</p>
      </section>

      <section className="supplier-stock-form__section supplier-stock-form__meta">
        <Row className="g-3">
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>SKU *</Form.Label>
              <Form.Control
                type="text"
                name="sku"
                value={formData.sku}
                onChange={handleChange}
                placeholder="VD: SHOE-001"
                required
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Tên sản phẩm *</Form.Label>
              <Form.Control
                type="text"
                name="productName"
                value={formData.productName}
                onChange={handleChange}
                placeholder="VD: Giày thể thao Nike"
                required
              />
            </Form.Group>
          </Col>
          <Col md={12}>
            <Form.Group className="mb-3">
              <Form.Label>Link hình ảnh</Form.Label>
              <Form.Control
                type="text"
                name="imageUrl"
                value={formData.imageUrl}
                onChange={handleChange}
                placeholder="https://example.com/image.jpg"
              />
            </Form.Group>
            {formData.imageUrl && (
              <div className="supplier-stock-form__image-preview">
                <img src={formData.imageUrl} alt="Preview" />
              </div>
            )}
          </Col>
        </Row>
      </section>

      <div className="d-grid gap-2 d-md-flex justify-content-md-end mt-4 supplier-stock-form__actions">
        <Button
          variant="secondary"
          className="me-md-2"
          onClick={() => setPopupShow(false)}
          disabled={submitting}
          type="button"
        >
          Huỷ
        </Button>
        <Button variant="primary" type="submit" disabled={submitting}>
          {submitting ? "Đang lưu..." : "Lưu sản phẩm"}
        </Button>
      </div>
    </Form>
  );
};

export default ProductForm;
